import React from "react"
import {Box, useTheme} from "@mui/material"
import {useDraggable} from "@dnd-kit/core"
import {CSS} from "@dnd-kit/utilities"
import {fileServerUrlParser} from "../../../misc/utils"

const CIRCLE_SIZE = 48

const EventMarker = ({event, leftPx, dashHeight}) => {
    const theme = useTheme()
    const eventColors = theme.EVENTSANDBARCHART?.event ?? {}
    const {attributes, listeners, setNodeRef, transform, isDragging} =
        useDraggable({id: event.id})

    const dragTransform = {
        x: transform?.x ?? 0,
        y: 0,
        scaleX: 1,
        scaleY: 1,
    }

    return (
        <Box
            ref={setNodeRef}
            {...listeners}
            {...attributes}
            sx={{
                position: "absolute",
                left: `${leftPx - CIRCLE_SIZE / 2}px`,
                bottom: 0,
                height: `${dashHeight}px`,
                width: `${CIRCLE_SIZE}px`,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "grab",
                pointerEvents: "auto",
                transform: CSS.Translate.toString(dragTransform),
                opacity: isDragging ? 0.75 : 1,
                zIndex: isDragging ? 1000 : 5,
                userSelect: "none",
                touchAction: "none",
            }}
        >
            <Box
                sx={{
                    width: `${CIRCLE_SIZE}px`,
                    height: `${CIRCLE_SIZE}px`,
                    borderRadius: "50%",
                    backgroundColor: eventColors.circleBackground,
                    border: `2px solid ${eventColors.circleBorder}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    flexShrink: 0,
                }}
            >
                {event.image ? (
                    <img
                        src={fileServerUrlParser(event.image)}
                        alt={event.longname ?? ""}
                        style={{width: "100%", height: "100%", objectFit: "cover"}}
                        draggable={false}
                    />
                ) : event.icon ? (
                    <img
                        src={fileServerUrlParser(event.icon)}
                        alt={event.longname ?? ""}
                        style={{width: "60%", height: "60%", objectFit: "contain"}}
                        draggable={false}
                    />
                ) : null}
            </Box>
            <Box
                sx={{
                    flex: 1,
                    width: 0,
                    borderLeft: `2px dashed ${eventColors.dashColor}`,
                    mt: 0.5,
                }}
            />
        </Box>
    )
}

export default EventMarker
